module.exports = __webpack_public_path__ + "img/menu-cad-active.733e7a1b.svg";